import { Participant } from "@apuestes/types";
import { initialParticipantState } from "../../../../_metronic/helpers";
import { createSlice } from "@reduxjs/toolkit";
import { apuestesAPI } from "../../services/apuestesAPI";

const participantSlice = createSlice({
    name: "participant",
    initialState: {
        meta: { fetch: false, id: -1 },
        value: initialParticipantState
    },
    reducers: {},
    extraReducers(builder) {
        builder
            .addMatcher(apuestesAPI.endpoints.getModelById.matchFulfilled, (state, action) => {
                if (action.meta.arg.originalArgs.model === 'participants') {
                    state.value = action.payload as Participant;
                }
            })
            .addMatcher(apuestesAPI.endpoints.updateModel.matchFulfilled, (state, action) => {
                if (action.meta.arg.originalArgs.model === 'participants') {
                    state.value = action.payload as Participant;
                }
            })
    },
});

export default participantSlice.reducer;